/// <amd-module name="Artifacts/Root/routing/Definitions" />

import * as Res from "Artifacts/Root/Resources";
import {
  connectToFeed,
  feedHubRoute,
  packageDetails,
  packageRecycleBinHubRoute,
  settingsRoute,
} from "Artifacts/Root/routing/Constants";
import { asLazyContainerComponent } from "Artifacts/Root/routing/Tools";
import { RouteProps } from "react-router-dom";

export const connectContainerName = "ms.azure-artifacts.connect.container";
export const packageContainerName = "ms.azure-artifacts.package.container";
export const feedHubContainerName = "ms.azure-artifacts.feedhub.container";
export const feedHubRedirectorContainerName = "ms.azure-artifacts.feedhub-redirect.container";
export const feedSettingsContainerName = "ms.azure-artifacts.feed-settings.container";
export const packageRecycleBinHubContainerName =
  "ms.azure-artifacts.package-recycle-bin-hub.container";
export const packageRecycleBinVersionContainerName =
  "ms.azure-artifacts.package-recycle-bin-version-list.container";

export const connectToFeedRoutes: RouteProps[] = [
  {
    path: connectToFeed,
    exact: true,
    component: asLazyContainerComponent(connectContainerName, Res.TabTitle_ConnectToFeed),
  },
];

export const packageDetailsRouter: RouteProps[] = [
  {
    path: packageDetails,
    exact: false,
    component: asLazyContainerComponent(packageContainerName, Res.TabTitle_PackageDetails),
  },
];

export const feedHubRoutes: RouteProps[] = [
  {
    path: feedHubRoute,
    exact: true,
    // don't provide tab title so that it will get filled in as the feed name
    component: asLazyContainerComponent(feedHubContainerName),
  },
];

export const feedSettingsRoutes: RouteProps[] = [
  {
    path: settingsRoute,
    exact: false,
    component: asLazyContainerComponent(feedSettingsContainerName, Res.TabTitle_FeedSettings),
  },
];

export const packageRecycleBinRoutes: RouteProps[] = [
  {
    path: packageRecycleBinHubRoute,
    exact: true,
    component: asLazyContainerComponent(
      packageRecycleBinHubContainerName,
      Res.TabTitle_PackageRecycleBin,
    ),
  },
];
